import React from 'react';

import Avatar from '@atlaskit/avatar/avatar';

const AvatarHexagonExample = (): React.JSX.Element => (
	<Avatar name="Rovo" appearance="hexagon" size="large" presence="online" />
);

export default AvatarHexagonExample;
